<template>
  <div class="min-wt1200" :class="`${workbenchCurrentStepPur> 0 ? `active-workbench-pur-step-item${workbenchCurrentStepPur}`:''}`">
    <div id="public-toolbar-new" style="position: relative;z-index: 999"/>
    <div>
      <div id="public-toolaside-new"/>
      <div class="workBench" :class="{'asideCollapse': isCollapse}">
        <div class="workBench-top mb15">
          <!-- 个人信息卡片 -->
          <person-info-card type="1" :personInfo="personInfo"></person-info-card>
        </div>
        <div  class="workBench-cont clearfix">
          <div class="workBench-right">
            <!-- 快捷菜单 -->
            <shortcut-menu></shortcut-menu>
            <!-- 轮播图 -->
            <carousel :bannerInfo="personInfo.bannerInfoDto"></carousel>
            <!-- 平台公告 -->
            <platform-announcement
                    :noticeDtos="personInfo.noticeDtos"
            ></platform-announcement>
            <!-- 企业管理 -->
            <business-management :orgManagerList="orgManagerList"></business-management>
            <!-- 操作指引 -->
            <opera-guideline :columnDtos="personInfo.columnDtos"></opera-guideline>
          </div>
          <div class="workBench-left">
            <!-- 状态类型卡片 -->
            <status-class-card class="mb15" :statusData="statusData"></status-class-card>
            <!-- 项目tab -->
            <item-tab class="mb15" type="1"></item-tab>
            <!-- 待办事项 -->
            <backlog-tab class="mb15"></backlog-tab>
            <!-- 协议tab -->
            <protocol-tab></protocol-tab>
          </div>
        </div>
        <!-- 底部版权 -->
        <!-- <footer-item></footer-item> -->
      </div>
        <!-- 底部版权 -->
      <div id="public-toolfooterlast" class="workbench-footer"></div>

      <!--    新手引导-->
      <novice-guidance-pur></novice-guidance-pur>
    </div>

    <el-dialog
        width="360px"
        :visible="showTip"
        :show-close="false"
        custom-class="dialogReminder"
        center>
        <!-- <div style="margin:20px 0;text-align:center">亲爱的用户，您不小心访问了没有权限的页面，系统即将跳转到您的工作台。</div>
        <span slot="footer" class="tip-dialog-footer">
            <el-button
                type="primary"
                size="small"
                @click="tipDialogHandle">确认跳转</el-button>
        </span> -->

      <div class="reminderCon">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/expression_icon.png" alt="">
        <p class="title">您好，此页面仅提供给采购商哦</p>
        <p><span class="number">1</span>亲爱的用户，您不小心访问了没有权限的页面，请点击立即前往跳转到您的工作台。</p>
        <!-- <p><span class="number">2</span>如果您是采购商，我们有“安心采”服务，专门帮助采购商降低采购风险 &nbsp<a @click="$router.push('creditReport')" style="color: #3F88E0;text-decoration: none;cursor: pointer;">立即查看</a></p> -->
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="tipDialogHandle">立即前往</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import personInfoCard from './components/personInfoCard.vue'
import statusClassCard from './components/statusClassCard'
import itemTab from './components/itemTab.vue'
import backlogTab from './components/backlogTab.vue'
import protocolTab from './components/protocolTab.vue'
import businessRecommend from './components/businessRecommend.vue'
import shortcutMenu from './components/shortcutMenu.vue'
import platformAnnouncement from './components/platformAnnouncement.vue'
import carousel from './components/carousel.vue'
import businessManagement from './components/businessManagement.vue'
import operaGuideline from './components/operaGuideline.vue'
import addTagDialog from './components/addTagDialog.vue'
import footerItem from './components/footerItem.vue'
import noviceGuidancePur from './components/noviceGuidancePur.vue'

import { loadScript } from '@/assets/js/utils'
import { mapState } from 'vuex'
export default {
  props: [],
  data () {
    return {
      personInfo: {},
      // 推荐商机
      pushSupplierInfo: {},
      statusData:[], // 卡片
      orgManagerList:[],//人员
      isCollapse: false,
      showTip:false,//是否有权限
    }
  },
  components: {
    'person-info-card': personInfoCard,
    'status-class-card': statusClassCard,
    'item-tab': itemTab,
    'backlog-tab': backlogTab,
    'protocol-tab': protocolTab,
    'shortcut-menu': shortcutMenu,
    'business-recommend': businessRecommend,
    'platform-announcement': platformAnnouncement,
    'carousel': carousel,
    'business-management': businessManagement,
    'opera-guideline': operaGuideline,
    'add-tag-dialog': addTagDialog,
    'footer-item': footerItem,
    'novice-guidance-pur': noviceGuidancePur
  },
  computed: mapState([
    'workbenchCurrentStepPur'
  ]),
  mounted () {
    // 获取当前展开状态
    this.$route.query.isCollapse == '1' && (this.isCollapse = true)
    loadScript('http://static.onelinkplus.com/p/onelink.arch.public.ui/v0.0.2/toolaside.js?version=3',() => {
      let aside = new window.onelink.ToolAside("public-toolaside-new", { isCollapse: this.isCollapse });
    });

    loadScript('http://static.onelinkplus.com/p/onelink.arch.public.ui/v0.0.2/toolbarNew.js?version=3',() => {
      new window.onelink.ToolbarNew("public-toolbar-new", { isShowAside: true, asideId: "public-toolaside-new"}, this.toggleAsideCB);
    });

    loadScript('http://static.onelinkplus.com/p/onelink.arch.public.ui/v0.0.2/toolfooterlast.js?version=3',() => {
      new window.onelink.ToolfooterLast("public-toolfooterlast");
    });
    this.init()
  },
  methods: {
    tipDialogHandle(){
      // 10 供应商，20采购商
      if(Cookies.get("userTag")=='10'){
        this.$router.push('/supplierWorkBench')
      }
      // this.$router.push('/purchaseWorkBench')
    },
    async init() {
      if(Cookies.get("userTag")=='10'){
        this.showTip=true
        // setTimeout(()=>{
        //   this.tipDialogHandle()
        // },3000)
      }else{
        this.showTip=false

        // 判断用户是否补全信息   未补全去补全 补全则弹出新手引导
        await this.$store.dispatch('findWebDtoHandler');
        this.$store.dispatch('informationCompletion', () => {
          if (this.getToken('isExperience') == 1) {
            this.$store.commit("changeWorkbenchStepPur", 1);
            let bodyHtml = document.querySelector('body');
            bodyHtml.style.overflowY = 'hidden';
          }
        });

      }
      // 人员信息
      this.findCardInfo()

      // 采购商端数据汇总概览 进行中的申请数量 进行中的项目数量 进行中的订单数量
      this.loadPurcahseCollect()

      // 推荐商机
      this.pushSupplierBizProject()

      // 查询企业管理员
      this.selectOrgManager()
    },
    // 采购商端数据汇总概览 进行中的申请数量 进行中的项目数量 进行中的订单数量
    loadPurcahseCollect() {
      this.$axios
        .get("/onelink.mdata.main.api/loadPurcahseCollect", {
          params: {
            language: "zh_CN"
          }
        })
        .then(res => {
          // console.info(res);
          this.$set(this, 'statusData', res.data.rows)
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 人员信息
    findCardInfo() {
      this.$axios
        .post("/onelink.mdata.main.api/card/findCardInfo")
        .then(res => {
          // console.info(res.data.data);
          if (res.data.code == 0) {
            this.personInfo = res.data.data;
          } else {
            this.$message.error(res.data.errorMsg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 推荐商机
    pushSupplierBizProject() {
      this.$axios
        .post("/onelink.mdata.main.api/card/pushSupplierBizProject")
        .then(res => {
          // console.info(res.data.data);
          if (res.data.code == 0) {
            this.pushSupplierInfo = res.data.data;
          } else {
            this.$message.error(res.data.errorMsg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // POST 查询企业管理员
    selectOrgManager () {
      this.$axios
        .post(`/onelink.mdata.main.api/recruitInfo/selectOrgManager?orgId=${Cookies.get("justId")}`)
        .then(res => {
          // console.info(res.data);
          // if (res.data.code == 0) {
          //   this.orgManagerList = res.data;
          // } else {
          //   this.$message.error(res.data.errorMsg);
          // }
            // this.orgManagerList = res.data;
            this.$set(this,'orgManagerList',res.data)
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 切换菜单回调
    toggleAsideCB () {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>
<style lang="stylus">


  .workbench-footer{
    .co-public-toolfooterlast{
      background-color: #f0f2f5;
    }
    .co-public-toolfooterlast .toolfooter-copyright{
      border-top: 1px solid #dcdfe6;
    }
  }
  .co-public-toolbar-new .toolbar-container{
    z-index: 999 !important;
  }
.min-wt1200{
  min-width: 1200px;
}
.workBench{
  margin-left:200px;
  margin-top: 60px;
  background:#f0f2f5;
  padding:15px;
  &.asideCollapse{
     margin-left: 46px;
   }
}
.workBench .mb15{
  margin-bottom: 15px;
}
.workBench-cont{

}
.workBench-left{
  margin-right :320px;
  padding-right:15px;
}
.workBench-right{
  width:320px;
  float:right;
}
.workBench .el-dialog__wrapper .el-dialog .el-dialog__footer .tip-dialog-footer .el-button {
  background: #5882F2;
  border-color: #5882F2;
  color: #ffffff !important;
}
.workBench .el-dialog__wrapper .el-dialog .el-dialog__footer .tip-dialog-footer .el-button:hover{
  background: #5882F2 !important;
  border-color: #5882F2;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/purchaseIndex.vue